import React from "react";

export interface PlainTextContentProps {
  content: string;
}

/**
 * PlainTextContent component for rendering simple text content.
 * Used primarily for user messages with basic text formatting.
 */
export const PlainTextContent = ({ content }: PlainTextContentProps) => {
  return <div className="body2 text-wrap break-words">{content}</div>;
};
